<template>
    <v-text-field :value="value" v-model="internal" @input="onChange()" :label="label">
    </v-text-field>
</template>

<script>
export default {
  props: ["value", "label"],
  data() {
    return {
      internal: ""
    };
  },
  methods: {
    onChange() {
      this.$emit("input", this.internal);
    }
  },
  created() {
    this.internal = this.value;
  },
  watch: {
    value() {
      this.internal = this.value;
    }
  }
};
</script>

